export default () => {

  document.addEventListener('DOMContentLoaded', function () {
    const fadeElements = document.querySelectorAll('.y-plus5');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          // 一度だけ監視したい場合は以下で監視解除
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1 // 10%が見えたら発火
    });
    fadeElements.forEach(el => observer.observe(el));
  });

}
